export class ChargePost {
    constructor(
        public holderFName: string,
        public holderLName: string,
        public holderMName: string,
        public creditCardNumber: string,
        public expirationDate: string,
        public cvc: string,
        public amount: string,
        public name: string,
        public address: string,
        public city: string,
        public state: string,
        public zip: string,
        public email: string,

        public account: string,
        public company: string,
        public dob: Date,
        public invoiceNo: string,
        public pType: string
        ) {
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/models/payment.model.ts